module.exports = __webpack_public_path__ + "static/media/band.9cb50705.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/band.svg
// module id = 302
// module chunks = 0